// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ul,\nol {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n", "",{"version":3,"sources":["webpack://./src/styles/lists.css"],"names":[],"mappings":"AAAA;;EAEE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB","sourcesContent":["ul,\nol {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
